<template>
    <div>
      <h1>About Page</h1>
      <p>Welcome to the home page!</p>
    </div>
  </template>
  
  <script>
  export default {
    // eslint-disable-next-line vue/multi-word-component-names
    name: "About",
  };
  </script>
  
  <style scoped>
  /* Add styles for Home page */
  </style>
  